const SECTION_ANCHOR_PREFIX = 'section-';
const HASH_PREFIX = '#';
const EMPTY_HASH = '#';
const SMOOTH_SCROLL_OPTIONS: ScrollIntoViewOptions = {
  behavior: 'smooth',
  block: 'start',
};

export interface AnchorTarget {
  readonly id: string;
  readonly hash: string;
}

export interface ScrollToAnchorOptions {
  readonly updateHash?: boolean;
}

export function sectionAnchorId(sectionId: string): string {
  return `${SECTION_ANCHOR_PREFIX}${sectionId}`;
}

export function normalizeAnchorTarget(raw: string): AnchorTarget | null {
  const trimmed = raw.trim();
  if (trimmed === '' || trimmed === EMPTY_HASH || !trimmed.startsWith(HASH_PREFIX)) {
    warnInvalidTarget(raw);
    return null;
  }
  const id = trimmed.slice(1);
  if (id === '' || id.includes(HASH_PREFIX)) {
    warnInvalidTarget(raw);
    return null;
  }
  return { id, hash: `${HASH_PREFIX}${id}` };
}

export function scrollToAnchor(
  target: AnchorTarget,
  options: ScrollToAnchorOptions = {},
): boolean {
  const element = document.getElementById(target.id);
  if (element === null) {
    // eslint-disable-next-line no-console
    console.warn(`[AnchorNav] target element not found: "${target.id}"`);
    return false;
  }
  element.scrollIntoView(SMOOTH_SCROLL_OPTIONS);
  if (options.updateHash !== false) {
    history.replaceState(null, '', target.hash);
  }
  return true;
}

function warnInvalidTarget(raw: string): void {
  // eslint-disable-next-line no-console
  console.warn(`[AnchorNav] invalid anchor target: "${raw}"`);
}
